import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column } from '@narvar/nth-grid';
import Carousel from '@narvar/nth-bundle-carousel';

const PickupCarousel = ({ items, render, slidesToShow }) => {
  const [currSlide, setCurrSlide] = React.useState(0);
  return (
    <Container>
      <Row lg-style="margin: 0 2.5rem;">
        <Column md-columns={8} md-column-offset={2} sm-columns={12} xs-style="position: relative;">
          <Carousel
            slickProps={{
              slidesToShow,
              dots: false,
              infinite: false,
              afterChange: null,
              responsive: [
                {
                  breakpoint: 660,
                  settings: {
                    slidesToShow: slidesToShow - 0.5,
                    focusOnSelect: true,
                    afterChange: (slide) => setCurrSlide(slide),
                  },
                },
              ],
              swipeToSlide: true,
            }}
            itemsCount={slidesToShow}
            carouselContainerStyles={{
              '@media (max-width: 660px)': {
                ':after':
                  currSlide > 0
                    ? {}
                    : {
                        background:
                          'linear-gradient(270deg, #FFFFFF 9.48%, rgba(255, 255, 255, 0) 100%)',
                        content: '""',
                        position: 'absolute',
                        right: '0',
                        top: '0',
                        width: '2rem',
                        height: '100%',
                        pointerEvents: 'none',
                      },
              },
            }}
            carouselControlsContainerStyles={{ display: 'none' }}
          >
            {items.map((item) => render(item))}
          </Carousel>
        </Column>
      </Row>
    </Container>
  );
};

PickupCarousel.defaultProps = {
  render: (item) => item,
  slidesToShow: 1,
};

PickupCarousel.propTypes = {
  items: PropTypes.array.isRequired,
  render: PropTypes.func,
  slidesToShow: PropTypes.number,
};

export default PickupCarousel;
